export default __webpack_public_path__ + "b90809e15b35e652f8936c32134f5291.svg";